import React from 'react';
import './ServicesOffered.css'
import ServicePageDecor from '../../assets/service-page-decor.svg'
import ServiceComponent from '../../components/serviceComponent/ServiceComponent.js';
import { SERVICES_OFFERED } from '../../common/Constants.js';


const Service = () => {
    return (
        <div className='service-page' id='service-page' >
            <div className='service-page-para'>
                <img className='service-page-decor' src={ServicePageDecor} alt='service Page Decor' />
                <p className='first-text-service'>We build AI systems that work autonomously.</p>
                <p className='second-text-service'>Our engineering team specializes in the full stack of agentic AI - from the LLM layer and retrieval systems to the automation pipelines and voice interfaces that make intelligent products run in the real world.</p>
            </div>
            <div className='service-page-components'>
                {SERVICES_OFFERED.map((service, index) => (
                    <ServiceComponent key={index}
                        imgSrc={service.imgSrc}
                        altText={service.altText}
                        firstText={service.firstText}
                        secondText={service.secondText}
                        images={service.images} />
                ))}
            </div>
        </div>
    )
}

export default Service;